<template>
  <div class="objectStorageSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>

      <Col span="3">
        <Select
          v-model="accountType"
          filterable
          :placeholder="$t('alarms.common.filterByAccountType')"
          :transfer="true"
        >
          <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in accountTypeList"
            :key="item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>

      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="accountName"
          :placeholder="$t('alarms.objectStorage.pleaseEnterAccountName')"
        />
      </Col>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="locationSearchKey"
          :placeholder="$t('alarms.objectStorage.pleaseEnterObjStoreName')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:objectStorageMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableObjectStorage from "../object_storage/TableObjectStorage";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tableObjectStorage = TableObjectStorage;
export default {
  name: "ObjectStorageSearch",
  data() {
    return {
      accountName: "",
      accountType: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      locationSearchKey: "",
      locationSearchName: "",
      accountTypeList: [
        {
          id: 0,
          name: "AWS"
        },
        {
          id: 1,
          name: "Aliyun"
        },
        // {
        //   id: 2,
        //   name: "Azure"
        // },
        // {
        //   id: 3,
        //   name: "VMware"
        // },
        {
          id: 4,
          name: "GCP"
        }
      ]
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountType", this.accountType);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("locationSearchName", this.locationSearchKey);
      tableObjectStorage.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 按公司搜索
    searchCompany: function() {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
    }
  }
};
</script>
<style scoped>
.objectStorageSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/object_storage/ObjectStorageSearch.vue